import { ErrorIcon } from "assets/icons";
import arrowHeadDown from "assets/svg/arrowHeadDownInInput.svg";
import { useState, useEffect } from "react";

const GInputWithDropDown = ({
  label,
  placeHolder,
  OriginalDataInArray,
  filteredDataInArray,
  setSelectedOption,
  setFilteredArray,
  defaultValue,
  required,
  error,
  onSelect, // Optional callback for additional actions
}: {
  label: string;
  placeHolder: string;
  OriginalDataInArray: string[];
  filteredDataInArray: string[] | undefined;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  setFilteredArray: React.Dispatch<React.SetStateAction<string[]>>;
  defaultValue?: string;
  required?: boolean;
  error?: string;
  onSelect?: (value: string) => void; // Optional callback
}) => {
  const [isGInputDropDown, setIsGInputDropDown] = useState(false);
  const [typedValue, setTypedValue] = useState("");
  const [selectedItemInDropdown, setSelectedItemInDropdown] = useState(false);

  // Set default value when component mounts or defaultValue changes
  useEffect(() => {
    if (defaultValue && !selectedItemInDropdown) {
      setTypedValue(defaultValue);
      setSelectedOption(defaultValue);
    }
  }, [defaultValue, selectedItemInDropdown]);

  // function
  const handleTypingFilter = (inputValue: string) => {
    setTypedValue(inputValue);
    let countryWithFirstCharacterInUppercase =
      inputValue.charAt(0).toUpperCase() + inputValue.slice(1).toLowerCase();
    setFilteredArray(
      OriginalDataInArray &&
        OriginalDataInArray?.filter((country) =>
          country.includes(countryWithFirstCharacterInUppercase)
        )
    );
  };

  return (
    <div>
      <label className="text-[#344054] mb-1 font-semibold text-sm font-grotesk relative">
        {label}
        {required && (
          <span className="flex absolute -right-2 text-[#ED6E33] -top-1 items-center text-xl">
            *
          </span>
        )}
      </label>
      <div className="relative">
        <div
          className={`bg-[#F6F3EF] flex justify-between items-center w-[100%] h-12 rounded-lg px-3 border-2 transition-colors ${
            error
              ? "border-[#F04438] focus-within:border-[#F04438]"
              : "border-transparent focus-within:border-[#F6F3EF]"
          }`}
        >
          <input
            type="text"
            onClick={() => setIsGInputDropDown((prev) => !prev)}
            value={typedValue}
            onChange={(e: any) => handleTypingFilter(e.target.value)}
            className="outline-0 bg-[#F6F3EF] w-[100%] h-[100%]"
            placeholder={placeHolder}
          />

          <img
            onClick={() => setIsGInputDropDown((prev: boolean) => !prev)}
            src={arrowHeadDown}
            alt=""
            className="cursor-pointer"
          />
        </div>

        {/* Dropdown */}
        <div
          style={{ boxShadow: "5px 5px 30px rgba(0, 0, 0, 0.2)" }}
          className={`absolute max-h-[120px] overflow-y-auto z-10 w-[100%] px-3 text-sm font-semibold font-grotesk bg-[white] border-2 border-[#F6F3EF] rounded-lg top-12 ${
            isGInputDropDown ? `block` : `hidden`
          }`}
        >
          {filteredDataInArray && filteredDataInArray.length > 0 ? (
            filteredDataInArray?.map((data: string, index: number) => (
              <div
                className={`flex flex-col gap-2 cursor-pointer py-2 hover:bg-gray-100`}
                key={index}
                onClick={() => {
                  setSelectedItemInDropdown(true);
                  setSelectedOption(`${data}`);
                  setTypedValue(data);
                  setIsGInputDropDown((prev) => !prev);
                  onSelect?.(data); // Call optional callback
                }}
              >
                {data}
              </div>
            ))
          ) : (
            <div className="py-2 text-gray-500">No results found</div>
          )}
        </div>

        {/* Error message */}
        {error && (
          <div className="flex items-start gap-1.5 mt-1.5">
            <ErrorIcon className="mt-0.5 flex-shrink-0" />
            <p className="text-[#F04438] text-xs lg:text-sm font-sfRegular">
              {error}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GInputWithDropDown;
